import { render, staticRenderFns } from "./PoCreate.vue?vue&type=template&id=a964e634&scoped=true&"
import script from "./PoCreate.vue?vue&type=script&lang=js&"
export * from "./PoCreate.vue?vue&type=script&lang=js&"
import style0 from "./PoCreate.vue?vue&type=style&index=0&id=a964e634&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a964e634",
  null
  
)

export default component.exports